(function(){
function init(root){
 root.querySelectorAll('[data-dn-gallery]').forEach(function(g){
  var main=g.querySelector('[data-dn-main]');
  g.querySelectorAll('[data-dn-thumb]').forEach(function(t){t.addEventListener('click',function(){
   g.querySelectorAll('[data-dn-thumb]').forEach(function(x){x.classList.remove('is-on')});t.classList.add('is-on');
   main.innerHTML=t.querySelector('template').innerHTML;});});
 });
 root.querySelectorAll('[data-dn-car]').forEach(function(c){
  var tr=c.querySelector('[data-dn-track]');
  c.querySelectorAll('[data-dn-dir]').forEach(function(b){b.addEventListener('click',function(){
   var first=tr.firstElementChild; var step=first?first.getBoundingClientRect().width+12:300;
   var dir=+b.getAttribute('data-dn-dir'); var max=tr.scrollWidth-tr.clientWidth-2;
   if(dir>0&&tr.scrollLeft>=max){tr.scrollTo({left:0,behavior:'smooth'});return}
   if(dir<0&&tr.scrollLeft<=0){tr.scrollTo({left:max,behavior:'smooth'});return}
   tr.scrollBy({left:dir*step,behavior:'smooth'});});});
 });
 root.querySelectorAll('[data-dn-reviews]').forEach(function(r){
  var tabs=r.querySelectorAll('[data-dn-tab]'),note=r.querySelector('[data-dn-note]'),cards=r.querySelectorAll('[data-dn-tagged]');
  function show(name){tabs.forEach(function(t){t.classList.toggle('is-on',t.getAttribute('data-dn-tab')===name)});
   var any=false;cards.forEach(function(c){var tags=(c.getAttribute('data-dn-tagged')||'').toLowerCase();var ok=!name||tags===''||tags.indexOf(name.toLowerCase())>-1;c.hidden=!ok;any=any||ok});
   if(!any)cards.forEach(function(c){c.hidden=false});
   if(note)note.textContent=(note.getAttribute('data-prefix')||'')+' '+name;
   var tr=r.querySelector('[data-dn-track]');if(tr)tr.scrollLeft=0;}
  tabs.forEach(function(t){t.addEventListener('click',function(){show(t.getAttribute('data-dn-tab'))})});
  if(tabs[0])show(tabs[0].getAttribute('data-dn-tab'));
 });
 root.querySelectorAll('[data-dn-form]').forEach(function(f){
  var sticky=document.querySelector('[data-dn-sticky="'+f.id+'"]'),btn=f.querySelector('[type=submit]'),cta=btn?btn.getAttribute('data-dn-cta'):'';
  function sync(){var c=f.querySelector('input[name=id]:checked');if(!c)return;var ok=c.getAttribute('data-dn-avail')==='true';
   if(btn){btn.disabled=!ok;btn.textContent=ok?cta:'Sold out';}
   if(sticky){var p=sticky.querySelector('[data-dn-stprice]');if(p)p.textContent=c.getAttribute('data-dn-label');}
   if(window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',c.value);history.replaceState({},'',u);}}
  f.addEventListener('change',sync);sync();
  if(sticky){sticky.querySelector('button').addEventListener('click',function(){if(f.requestSubmit)f.requestSubmit();else f.submit();});
   if('IntersectionObserver' in window&&btn){new IntersectionObserver(function(e){sticky.classList.toggle('is-on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(btn);}}
 });
}
document.addEventListener('DOMContentLoaded',function(){init(document)});
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();